<template>
  <div
    class="value-slider"
    data-test="simulator-value-slider"
  >
    <div class="value-slider__top">
      <div>
        <span class="value-slider__label">{{ sendLabel }}</span>
        <AnimatedValue
          class="value-slider__amount"
          :value="amountText"
        />
      </div>
      <PhArrowRight :size="20" />
      <div class="value-slider__right">
        <span class="value-slider__label">{{ payLabel }}</span>
        <AnimatedValue
          class="value-slider__amount"
          :value="totalText"
        />
      </div>
    </div>
    <v-slider
      :value="position"
      :min="0"
      :max="$options.STOPS.length - 1"
      :step="1"
      hide-details
      color="primary"
      track-color="grey lighten-2"
      :aria-label="sendLabel"
      data-test="slider-valor"
      @input="onSlide"
    />
  </div>
</template>

<script>
import { PhArrowRight } from 'phosphor-vue';
import AnimatedValue from '@/components/comum/AnimatedValue.vue';
import numberUtils from '../../../../common/utils/number';

const STOPS = [100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 250000, 500000, 1000000];

/** Atalho para o valor da simulação: arrastar muda o mesmo campo que o operador digita. */
export default {
  name: 'SimulatorValueSlider',

  STOPS,

  components: { AnimatedValue, PhArrowRight },

  props: {
    amount: {
      type: Number,
      default: 0
    },
    totalValue: {
      type: Number,
      default: 0
    },
    currencyCode: {
      type: String,
      default: ''
    }
  },

  computed: {
    position() {
      const next = STOPS.findIndex((stop) => stop >= this.amount);

      return next < 0 ? STOPS.length - 1 : next;
    },

    amountText() {
      return this.currencyCode ? numberUtils.formatCurrency(this.currencyCode, this.amount) : '';
    },

    totalText() {
      return numberUtils.formatCurrency('BRL', this.totalValue);
    },

    sendLabel() {
      return this.$t('simulator.slider.send');
    },

    payLabel() {
      return this.$t('simulator.slider.pay');
    }
  },

  methods: {
    onSlide(position) {
      this.$emit('change', STOPS[position]);
    }
  }
};
</script>

<style lang="scss" scoped>
.value-slider {
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tc-space-3);
    margin-bottom: var(--tc-space-2);
  }

  &__right {
    text-align: right;
  }

  &__label {
    display: block;
    font-size: var(--tc-fs-sm);
    color: var(--tc-text-2);
  }

  &__amount {
    font-family: var(--tc-font-display);
    font-size: var(--tc-fs-h2);
    font-weight: var(--tc-fw-semibold);
  }
}
</style>
